import { useState } from 'react';
import FestivalLinks from '../../../components/FestLinks/FestLinks';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './VratKatha.scss';

const vratKathas = [
  {
    id: 1,
    name: 'Shri Satyanarayana Vrat Katha',
    img: 'https://i.ibb.co/gS3bZ7C/satyanarayan.jpg',
    description:
      'Shri Satyanarayana Vrat Katha narrates the divine glory of Lord Vishnu in His benevolent Satyanarayana form, the embodiment of truth and righteousness. This sacred vrat is traditionally observed on Purnima and is performed to seek prosperity, harmony in married life, success in endeavors, and relief from financial or domestic troubles. The katha describes how devotion, truthfulness, and faith lead to divine grace, while negligence and falsehood invite suffering. Listening to the katha with sincerity is believed to remove hardships, fulfill noble desires, restore peace in the household, and guide devotees on the path of dharma.'
  },
  {
    id: 2,
    name: 'Ekadashi Vrat Katha',
    img: 'https://i.ibb.co/MnXHdnC/ekadashi.jpg',
    description:
      'Ekadashi Vrat Katha is devoted to Lord Vishnu and is observed twice every lunar month during Shukla and Krishna Paksha. The katha explains the spiritual significance of Ekadashi as a day for self-discipline, detachment, and devotion. Observing the fast and listening to the katha are believed to cleanse accumulated sins, control material desires, and purify the body and mind. Ekadashi vrat is said to grant devotion, inner strength, peace, and ultimately moksha, liberating the soul from the cycle of birth and death.'
  },
  {
    id: 3,
    name: 'Utpanna Ekadashi Katha',
    img: 'https://i.ibb.co/4T9jRr6/utpanna-ekadashi.jpg',
    description:
      'Utpanna Ekadashi Katha describes the divine origin of Ekadashi Devi, who emerged from Lord Vishnu to defeat the powerful demon Mura. Pleased with her devotion and courage, Lord Vishnu blessed her with the boon that those who observe Ekadashi vrat would be freed from sins and attain spiritual merit. This katha marks the beginning of Ekadashi observances and highlights the triumph of divine will over negativity. Observing this vrat is believed to remove obstacles, purify karma, and strengthen spiritual resolve.'
  },
  {
    id: 4,
    name: 'Sankashti Chaturthi Vrat Katha',
    img: 'https://i.ibb.co/SQFMcmn/sankashti.jpg',
    description:
      'Sankashti Chaturthi Vrat Katha glorifies Lord Ganesha, the remover of obstacles and the bestower of wisdom. Observed on the fourth day of Krishna Paksha, devotees observe a strict fast until moonrise and listen to the katha in the evening. The katha narrates stories where devotion to Lord Ganesha helps overcome sorrow, failure, and fear. Observing Sankashti vrat is believed to grant success, intelligence, prosperity, and fulfillment of sincere wishes, while protecting devotees from misfortune.'
  },
  {
    id: 5,
    name: 'Pradosha Vrat Katha',
    img: 'https://i.ibb.co/Pradosh.jpg',
    description:
      'Pradosha Vrat Katha is dedicated to Lord Shiva and Goddess Parvati and is observed on Trayodashi during the sacred twilight period. The katha explains how Lord Shiva becomes especially compassionate during Pradosha time and blesses devotees who worship Him with devotion. Observing this vrat is believed to bring good health, longevity, marital harmony, prosperity, and spiritual progress. Listening to the katha helps devotees gain divine protection, inner strength, and relief from sins and sufferings.'
  },
  {
    id: 6,
    name: 'Navagraha Weekdays Vrat Katha',
    img: 'https://i.ibb.co/navagraha.jpg',
    description:
      'Navagraha Weekdays Vrat Katha is associated with the nine planetary deities that govern human destiny according to Vedic astrology. Each planet influences specific aspects of life such as health, career, relationships, and mental peace. Observing fasts and listening to these kathas help pacify planetary doshas, reduce negative astrological effects, and strengthen positive planetary influences. This vrat is believed to bring balance, stability, prosperity, and protection from unforeseen difficulties.'
  },
  {
    id: 7,
    name: 'Deities Weekdays Vrat Katha',
    img: 'https://i.ibb.co/deities.jpg',
    description:
      'Each weekday in Hindu tradition is dedicated to a specific deity such as Lord Shiva, Lord Hanuman, Lord Ganesha, Lord Vishnu, Goddess Lakshmi, or Lord Shani. The corresponding vrat katha narrates the divine qualities and blessings of that deity. Observing these vrats with devotion helps devotees receive benefits related to health, courage, knowledge, wealth, protection, and spiritual growth. These kathas inspire discipline, faith, and gratitude in daily life.'
  },
  {
    id: 8,
    name: 'Karwa Chauth Vrat Katha',
    img: 'https://i.ibb.co/karwachauth.jpg',
    description:
      'Karwa Chauth Vrat Katha is traditionally observed by married women for the long life, good health, and prosperity of their husbands. The katha highlights stories of unwavering devotion, patience, and marital love. Women observe a day-long fast without food or water and listen to the katha in the evening before breaking the fast after moonrise. This vrat symbolizes faith, sacrifice, and the sacred bond of marriage, and is believed to bring happiness and protection to the family.'
  },
  {
    id: 9,
    name: 'Ahoi Ashtami Vrat Katha',
    img: 'https://i.ibb.co/ahoi.jpg',
    description:
      'Ahoi Ashtami Vrat Katha is observed by mothers for the protection, well-being, and longevity of their children. The katha emphasizes the power of maternal devotion, repentance, and faith. According to tradition, sincere observance of this vrat helps safeguard children from illness, accidents, and hardships. The vrat is performed with deep devotion and prayer, symbolizing a mother’s unconditional love and spiritual strength.'
  },
  {
    id: 10,
    name: 'Diwali Legends',
    img: 'https://i.ibb.co/diwali.jpg',
    description:
      'Diwali Legends narrate the sacred stories associated with the festival of lights, including Lord Rama’s return to Ayodhya after defeating Ravana, the victory of good over evil, and the worship of Goddess Lakshmi for prosperity. These stories symbolize hope, renewal, inner illumination, and the triumph of righteousness. Listening to Diwali kathas inspires positivity, gratitude, and spiritual awakening in devotees.'
  },
  {
    id: 11,
    name: 'Dhanteras Legends',
    img: 'https://i.ibb.co/dhanteras.jpg',
    description:
      'Dhanteras Legends recount the emergence of Lord Dhanvantari, the divine physician, during the Samudra Manthan. This day is dedicated to health, wealth, and well-being. The katha explains the importance of worshipping Goddess Lakshmi and Lord Dhanvantari to invite prosperity, success, and protection from illness and misfortune. Observing this day with devotion is believed to bring long-term stability and abundance.'
  },
  {
    id: 12,
    name: 'Sharad Purnima Vrat Katha',
    img: 'https://i.ibb.co/sharadpurnima.jpg',
    description:
      'Sharad Purnima Vrat Katha is associated with the divine moonlight and the Raas Leela of Lord Krishna. It is believed that on this night the moon rays possess special healing and nourishing powers. Devotees prepare kheer and leave it under moonlight as an offering. Observing this vrat is said to bring good health, happiness, prosperity, and spiritual bliss, while deepening devotion toward Lord Krishna.'
  }
];


const VratKatha = () => {
  const [selectedKatha, setSelectedKatha] = useState(null);

  const openPopup = (katha) => {
    setSelectedKatha(katha);
  };

  const closePopup = () => {
    setSelectedKatha(null);
  };

  return (
    <div className="vratkatha-container">
      <InnerNav />
      <div className="vratkatha-content">
        <Zodiac />

        <div className="festival-header">
          <h4>Hindu Vrat Katha Collection</h4>
        </div>

        {/* <div className="festival-grid">
          {vratKathas.map((katha) => (
            <div className="festival-card" key={katha.id} onClick={() => openPopup(katha)}>
              <img
                src='https://c.ndtvimg.com/2022-11/79cigt6o_vrat_625x300_17_November_22.jpg'
                alt={katha.name}
              />
              <p>{katha.name}</p>
            </div>
          ))}
        </div> */}
        {!selectedKatha ? (
  <div className="festival-grid">
    {vratKathas.map((katha) => (
      <div
        className="festival-card clickable"
        key={katha.id}
        onClick={() => openPopup(katha)}
      >
        <img
          src="https://c.ndtvimg.com/2022-11/79cigt6o_vrat_625x300_17_November_22.jpg"
          alt={katha.name}
        />
        <p>{katha.name}</p>
      </div>
    ))}
  </div>
) : (
  <div className="katha-detail-view">
    <button className="back-btn" onClick={closePopup}>
      ← Back
    </button>

    <h2>{selectedKatha.name}</h2>

    <img
      src="https://c.ndtvimg.com/2022-11/79cigt6o_vrat_625x300_17_November_22.jpg"
      alt={selectedKatha.name}
    />

    <p>{selectedKatha.description}</p>
  </div>
)}


        {/* {selectedKatha && (
          <div className="avatar-popup" onClick={closePopup}>
            <div className="avatar-popup-inner" onClick={(e) => e.stopPropagation()}>
              <button className="close-btn" onClick={closePopup}>&times;</button>
              <h3>{selectedKatha.name}</h3>
              <img src="https://c.ndtvimg.com/2022-11/79cigt6o_vrat_625x300_17_November_22.jpg" alt={selectedKatha.name} />
              <p>{selectedKatha.description}</p>
            </div>
          </div>
        )} */}

        <FestivalLinks />
      </div>
      <Footer />
    </div>
  );
};

export default VratKatha;
